var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskCategoryFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d4a181;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill-rule:evenodd;}.cls-3{fill:#191847;}.cls-10,.cls-4{fill:#1f28cf;}.cls-5{fill:#2b44ff;}.cls-6{fill:#5c63ab;}.cls-7{fill:#dde3e9;}.cls-8{fill:#7a89fe;}.cls-9{mask:url(#mask);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 201.94,
    height: 140,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    className: "cls-1",
    width: 180,
    height: 140
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "finanza") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finanza"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.92,21.49c1.66,3.1,1.46,10.94-.68,11.5-.86.22-2.68-.32-4.54-1.44l1.17,8.23H43l2.37-11a7.73,7.73,0,0,1-2.07-5.58C43.72,17.05,52.26,18.4,53.92,21.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-3",
    d: "M50,17.93c-.91-.15-3.35-.25-3.8-.25-.29,0-.6.06-.77-.2a2.29,2.29,0,0,1-.13-.83c0-.29-.12-.58-.19-.87a8.55,8.55,0,0,0-.91-2.32,7.15,7.15,0,0,0-3.39-3.06,10.84,10.84,0,0,0-5.14-.71A22.94,22.94,0,0,0,30.41,11a10.91,10.91,0,0,1-5.13.49A12.21,12.21,0,0,1,20.73,9.4a8.47,8.47,0,0,0-5-1.38,9.59,9.59,0,0,0-4.59,1.73A7.44,7.44,0,0,0,8.17,13.1a4.56,4.56,0,0,0,.42,4.67c1.54,2,4.4,2.52,6.78,2.47a12.87,12.87,0,0,0,4-.74A38.3,38.3,0,0,0,24.25,17a12.45,12.45,0,0,1,2.37-.94,2.64,2.64,0,0,1,2.31.15,11,11,0,0,0,2.33,1.33,7.37,7.37,0,0,0,2.63.47A25.19,25.19,0,0,0,39,17.11a10.63,10.63,0,0,1,4.27-.3c.58.12,1.44.36,1.65,1-3.57.65-5,5.06-4,8.3.54,1.74,3.81,3.79,5.08,2.87.8-.58.31-1.35,0-1.85-.61-1-.82-2.21.3-2.88,1-.58,2,.8,2,.79a12.49,12.49,0,0,0,4.14-3.2c1.55.09,1.79-.94,1.42-1.78S51.25,18.13,50,17.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Leg",
    className: "cls-4",
    points: "40.69 63.55 54.48 99.99 64.14 126.84 69.65 126.84 56.37 63.55 40.69 63.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.29,63.55c-.15,12.51,0,29.34-.39,30.12q-.36.78-21.72,17.76L18,116.25Q43.39,99.9,44.68,97.73C46,95.55,52.5,75.51,55.89,63.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    className: "cls-3",
    d: "M10.19,114.66,15,111l3.87,4.61a35.4,35.4,0,0,0,3.46,11.69l-.88.74-7-8.34-2-3.23-.44.37Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Right-Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.63,132l.28-6h6a35.66,35.66,0,0,0,11.18,4.86V132H70.22l-3.73-.57V132Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "cls-2",
    d: "M25.07,57,31,58.13q-8.86,16.5-9.51,17.49c-1,1.48-.06,4.21.27,5.64-2.09.48-1.26-2.65-3.9-2a11.36,11.36,0,0,0-1.21.37l-.39.13c-1.76.61-3.37,1.16-5.1-.43-.28-.26-.48-1,.46-1.46,2.35-1,5.82-2.92,6.38-3.66Q19.09,72.71,25.07,57Zm58.1-8.81-.11.17h0l-.23.34C82,49.86,81.39,51,81.71,51.44s1.44,0,1.86.72c.28.51-1.52,1.13-5.41,1.84l-7.78,6-3.31-4.25,10.38-4.56A24.81,24.81,0,0,1,82.73,47C83.23,46.86,84.1,46.81,83.17,48.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Back",
    className: "cls-6",
    d: "M46.91,35l2.48-.42c5.4,5.23,7.6,17.8,11.2,19.46,3.4,1.58,8.23.05,14-2L76.3,56C71.1,61.6,60,66.35,55.5,63.64,48.31,59.3,46.65,43.79,46.91,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-7",
    d: "M36.11,66.13H58c1,0,.81-1.44.67-2.17-1.67-8.42-8.2-17.5-8.2-29.49l-6.33-1C39,41.89,37.14,52.24,36.11,66.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Front",
    className: "cls-6",
    d: "M46.28,33.48q8.52,29,4.7,38.67H31.23a72.54,72.54,0,0,1,2.69-14.54Q27.21,69.69,22.64,75l-4.59-.9q4.44-27.53,25.72-40.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "university"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-2",
    "data-name": "Mask"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    width: 180,
    height: 140
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-10",
    d: "M190.77,54.94a3,3,0,0,0,3-3v-3h6.1a2,2,0,0,0,2-2V42.75a2.2,2.2,0,0,0-1.26-1.88l-58.9-22.34a2.1,2.1,0,0,0-1.56,0L81.32,40.87a2.2,2.2,0,0,0-1.26,1.88v4.06a2,2,0,0,0,2,2h6.1v3a3,3,0,0,0,3,3Zm3,60.94V110.8a3,3,0,0,0-3-3h-9.15V59H165.37v48.75H149.12V59H132.87v48.75H116.62V59H100.37v48.75H91.23a3,3,0,0,0-3,3v5.08Zm6.1,16.24a2,2,0,0,0,2-2V126a6.1,6.1,0,0,0-6.1-6.09H86.16a6.1,6.1,0,0,0-6.1,6.09v4.06a2,2,0,0,0,2,2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.92,28.49c1.66,3.1,1.46,10.94-.68,11.5-.86.22-2.68-.32-4.54-1.44l1.17,8.23H43l2.37-11a7.73,7.73,0,0,1-2.07-5.58C43.72,24.05,52.26,25.4,53.92,28.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50,24.93c-.91-.15-3.35-.25-3.8-.25-.29,0-.6.06-.77-.2a2.29,2.29,0,0,1-.13-.83c0-.29-.12-.58-.19-.87a8.55,8.55,0,0,0-.91-2.32,7.15,7.15,0,0,0-3.39-3.06,10.84,10.84,0,0,0-5.14-.71A22.94,22.94,0,0,0,30.41,18a10.91,10.91,0,0,1-5.13.49,12.21,12.21,0,0,1-4.55-2.11,8.47,8.47,0,0,0-5-1.38,9.59,9.59,0,0,0-4.59,1.73A7.44,7.44,0,0,0,8.17,20.1a4.56,4.56,0,0,0,.42,4.67c1.54,2,4.4,2.52,6.78,2.47a12.87,12.87,0,0,0,4-.74A38.3,38.3,0,0,0,24.25,24a12.45,12.45,0,0,1,2.37-.94,2.64,2.64,0,0,1,2.31.15,11,11,0,0,0,2.33,1.33,7.37,7.37,0,0,0,2.63.47A25.19,25.19,0,0,0,39,24.11a10.63,10.63,0,0,1,4.27-.3c.58.12,1.44.36,1.65,1-3.57.65-5,5.06-4,8.3.54,1.74,3.81,3.79,5.08,2.87.8-.58.31-1.35,0-1.85-.61-1-.82-2.21.3-2.88,1-.58,2,.8,2,.79a12.49,12.49,0,0,0,4.14-3.2c1.55.09,1.79-.94,1.42-1.78S51.25,25.13,50,24.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "40.69 70.55 54.48 106.99 64.14 133.84 69.65 133.84 56.37 70.55 40.69 70.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.29,70.55c-.15,12.51,0,29.34-.39,30.12q-.36.78-21.72,17.76L18,123.25q25.37-16.35,26.66-18.52c1.3-2.18,7.82-22.22,11.21-34.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.19,121.66,15,118l3.87,4.61a35.4,35.4,0,0,0,3.46,11.69l-.88.74-7-8.34-2-3.23-.44.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.63,139l.28-6h6a35.66,35.66,0,0,0,11.18,4.86V139H70.22l-3.73-.57V139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.07,64,31,65.13q-8.86,16.5-9.51,17.49c-1,1.48-.06,4.21.27,5.64-2.09.48-1.26-2.65-3.9-2a11.36,11.36,0,0,0-1.21.37l-.39.13c-1.76.61-3.37,1.16-5.1-.43-.28-.26-.48-1,.46-1.46,2.35-1,5.82-2.92,6.38-3.66Q19.09,79.71,25.07,64Zm58.1-8.81-.11.17h0l-.23.34C82,56.86,81.39,58,81.71,58.44s1.44,0,1.86.72c.28.51-1.52,1.13-5.41,1.84l-7.78,6-3.31-4.25,10.38-4.56A24.81,24.81,0,0,1,82.73,54C83.23,53.86,84.1,53.81,83.17,55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.91,42l2.48-.42c5.4,5.23,7.6,17.8,11.2,19.46,3.4,1.58,8.23.05,14-2L76.3,63C71.1,68.6,60,73.35,55.5,70.64,48.31,66.3,46.65,50.79,46.91,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.11,73.13H58c1,0,.81-1.44.67-2.17-1.67-8.42-8.2-17.5-8.2-29.49l-6.33-1C39,48.89,37.14,59.24,36.11,73.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.28,40.48q8.52,29,4.7,38.67H31.23a72.54,72.54,0,0,1,2.69-14.54Q27.21,76.69,22.64,82l-4.59-.9q4.44-27.53,25.72-40.63Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskCategoryFinance);
export default __webpack_public_path__ + "static/media/ask-category-finance.2d670fc15080a94dcdad247202cfad86.svg";
export { ForwardRef as ReactComponent };